import * as React from 'react';

import * as styles from './styles.css';

export type TLayoutUserCardAction = {
  icon: React.ReactNode;
  content: React.ReactNode;
};

type TLayoutUserCardActions = {
  actions: TLayoutUserCardAction[];
};

export const UserCardActions: React.VFC<TLayoutUserCardActions> = ({ actions }) => {
  const items = React.useMemo(
    () =>
      actions.map(({ icon, content }, index) => (
        <div className={styles['actions_row']} key={`action_row_${index}`}>
          <div className={styles['icon']}>{icon}</div>
          <div className={styles['content']}>{content}</div>
        </div>
      )),
    [actions],
  );

  if (!items.length) {
    return null;
  }

  return (
    <div className={styles['actions']} data-testid="UserCardActions">
      {items}
    </div>
  );
};
